import * as XLSX from 'xlsx';

// "Export Report" on the admin "<Category> – Progress Report" page: an Excel file with a
// summary sheet (the cards, per course) and one sheet per course with its student rows
// as filtered on the page.

const STATUS_LABEL = { completed: 'Completed', in_progress: 'In Progress', not_started: 'Not Started' };

// '28 Sep 2026' (toLocaleDateString gives 'Sept' in some browsers).
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const fmtDate = (d) => {
  const date = d ? new Date(d) : null;
  return date && !Number.isNaN(date.getTime()) ? `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}` : '-';
};
const toDateKey = (date) =>
  [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
const pctOf = (part, whole) => (whole ? Math.round((part / whole) * 100) : 0);

export function studentRows(students, unit) {
  return students.map((s, index) => ({
    'Sr. No.': index + 1,
    'Student Name': s.name,
    Balagruha: s.balagruhas.join(', ') || '-',
    [`${unit} Completed`]: s.storiesCompleted,
    [`Total ${unit}`]: s.storiesTotal,
    'Progress (%)': s.progress,
    Status: STATUS_LABEL[s.status] || s.status,
    'Last Active': fmtDate(s.lastActive),
    'Assigned On': fmtDate(s.assignedAt),
  }));
}

export function summaryRows(sheets) {
  return sheets.map(({ course, students }) => {
    const count = (status) => students.filter((s) => s.status === status).length;
    const total = students.length;
    return {
      Course: course.title,
      'Students Assigned': total,
      Completed: count('completed'),
      'Completed (%)': pctOf(count('completed'), total),
      'In Progress': count('in_progress'),
      'In Progress (%)': pctOf(count('in_progress'), total),
      'Not Started': count('not_started'),
      'Not Started (%)': pctOf(count('not_started'), total),
    };
  });
}

// Excel sheet names: at most 31 characters, none of : \ / ? * [ ], unique in the workbook.
export function sheetName(title, used) {
  const base = (title || 'Course').replace(/[:\\/?*[\]]/g, ' ').trim().slice(0, 31) || 'Course';
  let name = base;
  for (let n = 2; used.has(name.toLowerCase()); n += 1) name = `${base.slice(0, 31 - String(n).length - 1)} ${n}`;
  used.add(name.toLowerCase());
  return name;
}

export default function exportCategoryProgress({ category, unit, sheets, today = new Date() }) {
  const workbook = XLSX.utils.book_new();
  const used = new Set(['summary']);
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(summaryRows(sheets)), 'Summary');
  sheets.forEach(({ course, students }) => {
    const rows = studentRows(students, unit);
    const sheet = rows.length
      ? XLSX.utils.json_to_sheet(rows)
      : XLSX.utils.aoa_to_sheet([['No students match the report filters.']]);
    XLSX.utils.book_append_sheet(workbook, sheet, sheetName(course.title, used));
  });
  const slug = category.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'category';
  const fileName = `${slug}-progress-report-${toDateKey(today)}.xlsx`;
  XLSX.writeFile(workbook, fileName);
  return fileName;
}
